
      import Cart from './cart.vue'
      import type { App, Plugin } from 'vue'

      export const CartPlugin: Plugin = {
        install(app: App) {
          app.component('Cart', Cart)
        },
      }
      export { Cart }
      